import { BI_BASE_URL } from '@app/contstants/endpoints';
import { api } from '@app/utils/api';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { ManagerClientsHashrateResponse } from '../types';
import { QUERY_KEY_MANAGER_PERFORMANCE } from '../query-keys';

type Params = {
  managerId: number | null;
};

const getManagerClientsHashrate = async ({ managerId }: Params) => {
  const { data } = await api.get<ManagerClientsHashrateResponse>(
    `${BI_BASE_URL}/managers/manager/${managerId}/clients/hashrate`
  );

  return data;
};

export const useGetManagerClientsHashrate = ({
  managerId,
}: Params): UseQueryResult<ManagerClientsHashrateResponse, unknown> => {
  return useQuery({
    queryKey: [QUERY_KEY_MANAGER_PERFORMANCE.CLIENTS_HASHRATE, managerId],
    queryFn: () => {
      return getManagerClientsHashrate({ managerId });
    },
    enabled: managerId !== null,
  });
};
